export default __webpack_public_path__ + "static/media/alethio3.ea1e30cf.png";